import { createFileRoute } from '@tanstack/react-router'
import FormTemplateVersionCreate from '../components/form-template-versions/form-template-version-create/FormTemplateVersionCreate'

export const Route = createFileRoute('/_a/templates/$templateId/versions/create')({
  component: FormTemplateVersionCreate,
})
